import { Button, Stack, Typography, Box, Card, CardContent, Divider } from "@mui/material";
import { useCart } from "../../contexts/cartContext";
import { usePopup } from "../../contexts/popupContext";
import { useAccount } from "../../contexts/accountContext";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export default function SingleProductOnlyPopup() {
  const cartContext = useCart();
  const popupContext = usePopup();
  const accountContext = useAccount();
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  const handleCheckout = () => {
    if (cartContext.cartItems.length === 0) return;
    // Close popup first
    popupContext.forceClose();
    if (accountContext.isLoggedIn) {
      navigate('/checkout');
    } else {
      try { localStorage.setItem('pendingCheckout', 'true'); } catch (e) { void e; }
      navigate('/auth');
    }
  };

  const handleRemoveCurrent = () => {
    try {
      cartContext.clearCart();
    } finally {
      popupContext.forceClose();
    }
  };

  return (
    <Stack alignItems={"center"} gap={2} sx={{ px: { xs: 1.5, sm: 2.5 }, py: { xs: 2, sm: 3 } }}>
      <Card
        elevation={0}
        sx={{
          width: '100%',
          maxWidth: 620,
          borderRadius: 4,
          bgcolor: '#FFFFFF',
          border: '1px solid #E5E7EB',
          boxShadow: '0px 22px 56px rgba(15, 23, 42, 0.14)',
        }}
      >
        <CardContent sx={{ px: { xs: 2, sm: 2.5 }, py: { xs: 2.1, sm: 2.35 } }}>
          <Stack spacing={1.5}>
            <Typography variant="h6" sx={{ fontWeight: 800, color: '#111827' }}>
              {t('cartPopup.oneProductPerCart', 'One product per cart')}
            </Typography>
            <Typography variant="body2" sx={{ color: '#6B7280' }}>
              {t('cartPopup.singleItemExplain', 'You can only add one product at a time. Checkout with the one you have in the cart right now or remove that item and add your desired product.')}
            </Typography>

            <Divider sx={{ my: 0.5 }} />

            <Stack direction={{ xs: 'column', sm: 'row' }} gap={0.9}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleCheckout}
                disabled={cartContext.cartItems.length === 0}
                sx={{ borderRadius: 999, fontWeight: 700, minHeight: 42 }}
              >
                {accountContext.isLoggedIn
                  ? t('cartPopup.proceedToCheckout', 'Proceed to checkout')
                  : t('cartPopup.loginToCheckout', 'Log in to checkout')}
              </Button>
              <Button
                fullWidth
                variant="outlined"
                onClick={handleRemoveCurrent}
                sx={{ borderRadius: 999, fontWeight: 700, minHeight: 42 }}
              >
                {t('cartPopup.removeCurrentItem', 'Remove current item')}
              </Button>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
}
